import {SupplyAccountLinkComponent} from "./components/supply-account-link/supply-account-link.component";
import {ShipperAccountLinkTooltipComponent} from "./components/shipper-account-link-tooltip/shipper-account-link-tooltip.component";
import {BzTooltip} from "@bringoz/ui";
import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {DemandAccountTableComponent} from "./components/demand-account-table/demand-account-table.component";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {DemandAccountTableRowComponent} from "./components/demand-account-table-row/demand-account-table-row.component";
import {AccountAvatarComponent} from "./components/account-avatar/account-avatar.component";
import {DemandAccountLinkComponent} from "./components/demand-account-link/demand-account-link.component";
import {CommonsModule} from "../../commons/angular/commons.module";
import {TranslateModule} from "@ngx-translate/core";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {NgxPermissionsModule} from "ngx-permissions";
import {ShipperAccountLinkComponent} from "./components/shipper-account-link/shipper-account-link.component";
import {DemandAccountItemComponent} from "./components/demand-account-item/demand-account-item.component";
import {
  DemandAccountsMultiSelectComponent
} from "./components/demand-accounts-multi-select/demand-accounts-multi-select.component";
import {
  DemandAccountsMultiSelectListComponent
} from "./components/demand-accounts-multi-select-list/demand-accounts-multi-select-list.component";
import {AgentsModule} from "../../agents/angular/agents.module";
import {FormsModule} from "@angular/forms";
import {AddressesModule} from "../../addresses/angular/addresses.module";
import {NgSelectModule} from "@ng-select/ng-select";

@NgModule({
  declarations: [
    DemandAccountItemComponent,
    DemandAccountTableComponent,
    DemandAccountTableRowComponent,
    AccountAvatarComponent,
    DemandAccountLinkComponent,
    ShipperAccountLinkComponent,
    DemandAccountsMultiSelectComponent,
    DemandAccountsMultiSelectListComponent,
    SupplyAccountLinkComponent,
    ShipperAccountLinkTooltipComponent
  ],
  imports: [
    BrowserModule,
    ScrollingModule,
    CommonsModule,
    NgbModule,
    AddressesModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild(),
    AgentsModule,
    FormsModule,
    NgSelectModule,
    BzTooltip
  ],
  providers: [],
    exports: [
        DemandAccountLinkComponent,
        ShipperAccountLinkComponent,
        DemandAccountsMultiSelectComponent,
        SupplyAccountLinkComponent,
        ShipperAccountLinkTooltipComponent
    ]
})

export class AccountsModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapAccountModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(AccountsModule);
};

export const downgradedAccountModule = downgradeModule(bootstrapAccountModule);
